/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Error_Page_Message_ForbiddenInputs */

const de_commons_error_page_message_forbidden = /** @type {(inputs: Commons_Error_Page_Message_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie haben nicht die erforderlichen Berechtigungen, um auf diese Seite zuzugreifen.`)
};

/** @type {(inputs: Commons_Error_Page_Message_ForbiddenInputs) => LocalizedString} */
const en_commons_error_page_message_forbidden = de_commons_error_page_message_forbidden;

/**

* @param {Commons_Error_Page_Message_ForbiddenInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_error_page_message_forbidden = /** @type {((inputs?: Commons_Error_Page_Message_ForbiddenInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Error_Page_Message_ForbiddenInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_error_page_message_forbidden(inputs)
	return en_commons_error_page_message_forbidden(inputs)
});